import React from "react";
import { Col, Form } from "react-bootstrap";
import { CondicionPago } from "models/ECF/CondicionPago";
import { SideInput } from "components/Inputs/SideBar/SideInput";

const CondicionPagoEdit = ({ condicionPago, setCondicionPago }) => {
  return condicionPago !== undefined &&
    (
      <Col>
        <Form
          action=""
          className="form-horizontal"
          id="TypeValidation"
          method="">

          <SideInput
            label="Descripción"
            name="Descripcion"
            type="text"
            value={condicionPago?.Descripcion || ""}
            setState={setCondicionPago}
            required
          />

          <SideInput
            label="Días"
            name="Dias"
            type="number"
            min={0}
            value={condicionPago?.Dias || 0}
            setState={setCondicionPago}
            required />

          <SideInput
            label="Estatus"
            name="Estatus"
            type="select"
            value={condicionPago?.Estatus || CondicionPago.ESTATUS_ACTIVO}
            setState={setCondicionPago}
            disabled={!condicionPago?.IdSec}
            options={CondicionPago.ESTATUS_LIST}
          />
        </Form>
      </Col>
    )
};
export default CondicionPagoEdit;
